import { useEffect, useState } from 'react';
import { useRootScope } from 'FrontRoyalAngular';
import { useAppHeaderViewModel } from './useAppHeaderViewModel';

export function useAppHeaderHasTopMessage() {
    const $rootScope = useRootScope();
    const AppHeaderViewModel = useAppHeaderViewModel();
    const [hasTopMessage, setHasTopMessage] = useState(false);

    useEffect(() => {
        const unwatch = $rootScope.$watch(
            () => AppHeaderViewModel.hasTopMessage,
            val => setHasTopMessage(!!val),
        );

        return () => unwatch();
    }, [$rootScope, AppHeaderViewModel]);

    return hasTopMessage;
}
